import SetPasswordLinkSentPage from "./SetPasswordLinkSentPageContainer";

export default SetPasswordLinkSentPage;
